import { render, staticRenderFns } from "./switchOrg.vue?vue&type=template&id=74ff079d&scoped=true&"
import script from "./switchOrg.vue?vue&type=script&lang=ts&"
export * from "./switchOrg.vue?vue&type=script&lang=ts&"
import style0 from "./switchOrg.vue?vue&type=style&index=0&id=74ff079d&prod&lang=scss&scoped=true&"
import style1 from "./switchOrg.vue?vue&type=style&index=1&id=74ff079d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ff079d",
  null
  
)

export default component.exports